<svg [ngStyle]="{'z-index':1}" #svgRef
      width="100%"
      height="100%"
      viewBox="0 0 1000 600"
      preserveAspectRatio="xMidYMid meet"
>
  <foreignObject width="100%" height="100%" xmlns="http://www.w3.org/2000/xhtml">
    <div class="text" xmlns="http://www.w3.org/2000/xhtml" [innerHTML]="textContent | htmlFromText">
    </div>
  </foreignObject>
</svg>
